<template>
  <!-- Customer Reviews -->
  <section class="customer-review-section section">
    <div class="customer-side-main-all">
      <div class="customer-side-left-img">
        <img src="@/assets/img/customer-review-after.png" alt="image">
      </div>
      <div class="customer-side-right-img">
        <img src="@/assets/img/customer-review-before.png" alt="image">
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-nine aos" data-aos="fade-up">													
            <span class="title-badge">Testimonials</span>
            <h2>What Our Client <span>Say’s</span></h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel customer-review-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexninecustomer" :key="item.id">
                <div class="customer-reviews-all aos" data-aos="fade-up">
                  <div class="customer-reviews-main">
                    <img :src="require(`@/assets/img/client/${item.image}`)" alt="image">
                    <div class="customer-quote">
                      <img src="@/assets/img/icons/customer-quote.svg" alt="image">
                    </div>
                  </div>
                  <h5>{{item.name}}</h5>
                  <p class="fs-14 fw-medium mb-3">{{item.location}}</p>
                  <div class="rating">
                    <i class="fa-solid fa-star filled"></i>
                    <i class="fa-solid fa-star filled"></i>
                    <i class="fa-solid fa-star filled"></i>
                    <i class="fa-solid fa-star filled"></i>
                    <i class="fa-solid fa-star filled"></i>
                    <span class="ms-1">5.0</span>
                  </div>
                  <p>Versatile and user-friendly platform for freelancers and businesses alike. Its interface is clean and intuitive, making it easy to post jobs, browse profiles, and manage projects. The range of services is impressive,</p>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Customer Reviews -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexninecustomer from "@/assets/json/indexninecustomer.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexninecustomer: indexninecustomer,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 1,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
